/**
 * Constantes do Rastreador que o menu (eager, chunk `index`) precisa conhecer.
 * Sem React e sem rede, no molde de `rede/rede-flags.ts`: o chunk `index` está
 * rente ao teto do orçamento, então nada além disto entra nele.
 */

/** Mestre: desligada, todo `/v1/rastreador*` responde 404 (D1). Vive na tabela `feature_flag`, nunca no bundle. */
export const FLAG_RASTREADOR_MESTRE = 'rastreador.habilitada'

/** Chave da sonda `GET /v1/rastreador/capacidades` (D20), compartilhada entre o menu e a tela. */
export const rastreadorCapacidadesKey = ['rastreador', 'capacidades'] as const
